import {DATE_VALIDATION_MESSAGE} from '@/utils/constants/commonConstants'
import {Constants, SCHEDULE_DROPDOWN, DATE_VALIDATION_TYPE} from '@/utils/constants/commonConstants'

export const useDatePickerInput = (fieldName, validationRules = []) => {
  // this function is for type start date
  const validateStartDateWithCurrentDate = startDate => {
    const today = new Date()
    today.setHours(0, 0, 0, 0) // Normalize to start of the day
    if (startDate) {
      const [month, day, year] = startDate.split('/').map(Number) // Ensure correct parsing
      const parsedStartDate = new Date(year, month - 1, day) // Month is 0-based in JS
      if (parsedStartDate < today) {
        return true
      }
    }
    return false
  }

  // this function is for validating start date with end date

  const validateStartDateAndEndDate = (selectedEndDate, selectedStartDate) => {
    const endDate = new Date(selectedEndDate) // Convert both dates to Date objects (ensure they are at midnight)
    const startDate = new Date(selectedStartDate)
    endDate.setHours(0, 0, 0, 0) // Normalize times to midnight (prevents issues with time differences)
    startDate.setHours(0, 0, 0, 0)
    const diffInMs = endDate - startDate // Calculate the difference in milliseconds
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24) // Convert milliseconds to days (1 day = 1000 * 60 * 60 * 24 ms)

    return diffInDays
  }

  // this function is for validating if the selected date is in the same year as the current date
  const validateSameYear = selectedDate => {
    if (!selectedDate) return false
    const today = new Date()
    const [month, day, year] = selectedDate.split('/').map(Number) // Ensure correct parsing
    if (!month || !day || !year) return false
    const parsedSelectedDate = new Date(year, month - 1, day) // Month is 0-based in JS
    if (!parsedSelectedDate) return false

    return parsedSelectedDate?.getFullYear() === today?.getFullYear()
  }

  // this function is for validating if the selected date is in the same month as the current date
  const validateSameMonth = selectedDate => {
    if (!selectedDate) return false
    const today = new Date()
    const [month, day, year] = selectedDate.split('/').map(Number) // Ensure correct parsing
    if (!month || !day || !year) return false
    const parsedSelectedDate = new Date(year, month - 1, day) // Month is 0-based in JS
    if (!parsedSelectedDate) return false

    return (
      parsedSelectedDate?.getFullYear() === today?.getFullYear() && parsedSelectedDate?.getMonth() === today?.getMonth()
    )
  }

  const validateDates = selectedDate => {
    let errorList = []
    const rules = [...validationRules]
    const label = fieldName.replace('*', '')
    rules.forEach(rule => {
      if (rule.type === Constants.Required && !selectedDate) {
        errorList.push(`${label}  ${rule.msg}`)
      }
      // Start date should not be greater than end date startDateDiff > 0
      if (rule.type === DATE_VALIDATION_TYPE.START_DATE && rule.endDate) {
        const startDateDiff = validateStartDateAndEndDate(selectedDate, rule.endDate)
        startDateDiff > 0
          ? errorList.push(`${label}  ${DATE_VALIDATION_MESSAGE.CAN_NOT_BE_GREATOR_THAN_END_DATE}`)
          : null
      }

      if (rule.type === DATE_VALIDATION_TYPE.START_DATE) {
        validateStartDateWithCurrentDate(selectedDate) ? errorList.push(`${label}  ${rule.msg}`) : null
      }
      // End date should not be less than start date endDateDiff < 0
      if (rule.type === DATE_VALIDATION_TYPE.END_DATE && rule.startDate) {
        const endDateDiff = validateStartDateAndEndDate(selectedDate, rule.startDate)
        endDateDiff < 0 ? errorList.push(`${label} ${rule.msg}`) : null
      }

      if (
        rule.type === DATE_VALIDATION_TYPE.SCHEDULE_YEAR &&
        rule?.schedule?.toLowerCase() === SCHEDULE_DROPDOWN.END_OF_YEAR
      ) {
        !validateSameYear(selectedDate) ? errorList.push(`${label} ${rule.msg}`) : null
      }

      if (
        rule.type === DATE_VALIDATION_TYPE.SCHEDULE &&
        rule?.schedule?.toLowerCase() === SCHEDULE_DROPDOWN.END_OF_MONTH
      ) {
        !validateSameMonth(selectedDate) ? errorList.push(`${label} ${rule.msg}`) : null
      }
    })

    return errorList[0]
  }

  return {
    validateDates,
  }
}
